function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { Auth } from 'aws-amplify';
var API_BASE_URL = process.env.COSMOS_DATA_API_URL;

var createPremiumSubscriptions =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = fetch;
            _context.t1 = "".concat(API_BASE_URL, "/payments/subscriptions/premium/createagreement");
            _context.next = 4;
            return getApiRequestHeaders();

          case 4:
            _context.t2 = _context.sent;
            _context.t3 = {
              method: 'GET',
              mode: 'cors',
              headers: _context.t2
            };

            _context.t4 = function (r) {
              return r.json();
            };

            return _context.abrupt("return", (0, _context.t0)(_context.t1, _context.t3).then(_context.t4));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function createPremiumSubscriptions() {
    return _ref.apply(this, arguments);
  };
}();

var executePremiumSubscriptions =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(token) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.t0 = fetch;
            _context2.t1 = "".concat(API_BASE_URL, "/payments/subscriptions/premium/processagreement");
            _context2.next = 4;
            return getApiRequestHeaders();

          case 4:
            _context2.t2 = _context2.sent;
            _context2.t3 = JSON.stringify({
              token: token
            });
            _context2.t4 = {
              method: 'POST',
              mode: 'cors',
              headers: _context2.t2,
              body: _context2.t3
            };

            _context2.t5 = function (r) {
              return r.json();
            };

            return _context2.abrupt("return", (0, _context2.t0)(_context2.t1, _context2.t4).then(_context2.t5));

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function executePremiumSubscriptions(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var createNormalSubscriptions =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3() {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.t0 = fetch;
            _context3.t1 = "".concat(API_BASE_URL, "/payments/subscriptions/createagreement");
            _context3.next = 4;
            return getApiRequestHeaders();

          case 4:
            _context3.t2 = _context3.sent;
            _context3.t3 = {
              method: 'GET',
              mode: 'cors',
              headers: _context3.t2
            };

            _context3.t4 = function (r) {
              return r.json();
            };

            return _context3.abrupt("return", (0, _context3.t0)(_context3.t1, _context3.t3).then(_context3.t4));

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function createNormalSubscriptions() {
    return _ref3.apply(this, arguments);
  };
}();

var executeNormalSubscriptions =
/*#__PURE__*/
function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(token) {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.t0 = fetch;
            _context4.t1 = "".concat(API_BASE_URL, "/payments/subscriptions/processagreement");
            _context4.next = 4;
            return getApiRequestHeaders();

          case 4:
            _context4.t2 = _context4.sent;
            _context4.t3 = JSON.stringify({
              token: token
            });
            _context4.t4 = {
              method: 'POST',
              mode: 'cors',
              headers: _context4.t2,
              body: _context4.t3
            };

            _context4.t5 = function (r) {
              return r.json();
            };

            return _context4.abrupt("return", (0, _context4.t0)(_context4.t1, _context4.t4).then(_context4.t5));

          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function executeNormalSubscriptions(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

function getApiRequestHeaders() {
  return _getApiRequestHeaders.apply(this, arguments);
}

function _getApiRequestHeaders() {
  _getApiRequestHeaders = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee5() {
    var session;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return Auth.currentSession();

          case 2:
            session = _context5.sent;
            return _context5.abrupt("return", {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              cookies: session.accessToken.jwtToken
            });

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));
  return _getApiRequestHeaders.apply(this, arguments);
}

export default {
  createPremiumSubscriptions: createPremiumSubscriptions,
  executePremiumSubscriptions: executePremiumSubscriptions,
  createNormalSubscriptions: createNormalSubscriptions,
  executeNormalSubscriptions: executeNormalSubscriptions
};